"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProduct = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _useVariant = require("./use-variant");
var _useVariationParams = require("./use-variation-params");
var _useVariationAttributes = require("./use-variation-attributes");
var _contexts = require("../commerce-api/contexts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
// TODO: This needs to be refactored.
/**
 * Receive and productId or a product and parse the object to an specific format
 * @param {string | Object} [item] - The prop could be a string (productId) or a product itself (complete object)
 * @param {boolean} isProductPartOfSet - Is this product part of a set?
 * @returns {Object} - The product details parsed
 */
const useProduct = (item, isProductPartOfSet = false) => {
  var _product$c_inventory;
  const api = (0, _contexts.useCommerceAPI)();
  const [product, setProduct] = (0, _react.useState)(typeof item !== 'string' ? item : undefined);
  const [showLoading, setShowLoading] = (0, _react.useState)(true);
  const variant = (0, _useVariant.useVariant)(product, isProductPartOfSet);
  const variationParams = (0, _useVariationParams.useVariationParams)(product, isProductPartOfSet);
  const variationAttributes = (0, _useVariationAttributes.useVariationAttributes)(product, isProductPartOfSet);
  const stockLevel = (product === null || product === void 0 ? void 0 : (_product$c_inventory = product.c_inventory) === null || _product$c_inventory === void 0 ? void 0 : _product$c_inventory.stockLevel) || 0;
  const stepQuantity = (product === null || product === void 0 ? void 0 : product.stepQuantity) || 1;
  const minOrderQuantity = stockLevel > 0 ? (product === null || product === void 0 ? void 0 : product.minOrderQuantity) || 1 : 0;
  const initialQuantity = (product === null || product === void 0 ? void 0 : product.quantity) || (product === null || product === void 0 ? void 0 : product.minOrderQuantity) || 1;
  const [quantity, setQuantity] = (0, _react.useState)(initialQuantity);

  // If the `initialQuantity` changes, update the state. This typically happens
  // when either the master product changes, or the inventory of the product changes
  // from out-of-stock to in-stock or vice versa.
  (0, _react.useEffect)(() => {
    setQuantity(initialQuantity);
  }, [initialQuantity]);
  (0, _react.useEffect)(() => {
    const abortController = new AbortController();
    if (typeof item === 'string') {
      // @ts-ignore
      api.shopperProducts.getProduct({
        parameters: {
          id: item,
          signal: abortController.signal
        }
      }).then(res => {
        if (!abortController.signal.aborted) {
          setProduct(res);
        }
      }).catch(err => console.error(err)).finally(() => {
        if (!abortController.signal.aborted) {
          setShowLoading(false);
        }
      });
    } else {
      setProduct(item);
    }
    return () => abortController.abort();
  }, [item]);
  if (product) {
    return _objectSpread(_objectSpread({}, product), {}, {
      showLoading: false,
      variationAttributes,
      quantity,
      minOrderQuantity,
      stepQuantity,
      variationParams,
      setQuantity,
      variant,
      stockLevel
    });
  }
  return {
    showLoading
  };
};
exports.useProduct = useProduct;